var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { User } from '@/modules/users/models/User';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { Config } from '../models/Config';
import LocalizationModule from '@/modules/localization';
import { getAppInstance } from '@/modules/app';
import { getModule } from '@/modules/store';
var ConfigStore = (function (_super) {
    __extends(ConfigStore, _super);
    function ConfigStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.user = new User();
        _this.userToken = '';
        _this.config = new Config();
        _this.isAdmin = false;
        _this.organizationName = '';
        _this.organizationWebsiteUrl = '';
        _this.organizationPictureUrl = '';
        _this.folderName = '';
        return _this;
    }
    ConfigStore.prototype.setUser = function (user) {
        this.user = user;
    };
    ConfigStore.prototype.setUserToken = function (userToken) {
        this.userToken = userToken;
    };
    ConfigStore.prototype._setUserLanguage = function (lang) {
        console.log('_setUserLanguage', lang);
        this.user.language = lang;
    };
    ConfigStore.prototype.setConfig = function (config) {
        this.config = config;
    };
    ConfigStore.prototype.setOrganizationData = function (_a) {
        var _b = _a.organizationName, organizationName = _b === void 0 ? '' : _b, _c = _a.organizationWebsiteUrl, organizationWebsiteUrl = _c === void 0 ? '' : _c, _d = _a.folderName, folderName = _d === void 0 ? '' : _d, _e = _a.organizationPictureUrl, organizationPictureUrl = _e === void 0 ? '' : _e;
        this.organizationName = organizationName;
        this.organizationWebsiteUrl = organizationWebsiteUrl;
        this.folderName = folderName;
        this.organizationPictureUrl = organizationPictureUrl;
    };
    Object.defineProperty(ConfigStore.prototype, "userLanguage", {
        get: function () {
            var localizationModule = getAppInstance().getModuleByType(LocalizationModule);
            return localizationModule.i18n.locale;
        },
        enumerable: false,
        configurable: true
    });
    ConfigStore.prototype.setUserLanguage = function (lang) {
        return new Promise(function (resolve, reject) {
            console.log('setUserLanguage', lang);
            if (!lang)
                lang = 'en';
            var localizationModule = getAppInstance().getModuleByType(LocalizationModule);
            localizationModule.setLocale(lang);
            resolve(true);
        });
    };
    __decorate([
        Mutation
    ], ConfigStore.prototype, "setUser", null);
    __decorate([
        Mutation
    ], ConfigStore.prototype, "setUserToken", null);
    __decorate([
        Mutation
    ], ConfigStore.prototype, "_setUserLanguage", null);
    __decorate([
        Mutation
    ], ConfigStore.prototype, "setConfig", null);
    __decorate([
        Mutation
    ], ConfigStore.prototype, "setOrganizationData", null);
    __decorate([
        Action
    ], ConfigStore.prototype, "setUserLanguage", null);
    ConfigStore = __decorate([
        Module({ name: 'config' })
    ], ConfigStore);
    return ConfigStore;
}(VuexModule));
export default ConfigStore;
export function getConfigStore() {
    return getModule(ConfigStore);
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/config/store/ConfigStore.ts
// module id = fdkI
// module chunks = 10